import { createApp } from 'vue';
import GetTalentReportForm from '../../../health/GetTlntReportForm.vue'

const appElements = document.querySelectorAll('.vue-get-health-form-view')
Array.from(appElements).forEach(element => {
    createApp(GetTalentReportForm).mount(element);
});